/**
 * PartnerDisabled Component
 * Displays when partner is not live
 */

import React from 'react';

import { PartnerDisabledData } from '../../store/types';
import { LandingPageLayout } from '../landing-page-layout';

import './partner-disabled.scss';

export interface PartnerDisabledProps {
    data: PartnerDisabledData;
}

export const PartnerDisabled: React.FC<PartnerDisabledProps> = ({ data }) => {
    return (
        <LandingPageLayout wide className="partner-disabled">
            <div className="partner-disabled__content">
                {data.brandImage && <img src={data.brandImage} alt="Partner logo" className="partner-disabled__logo" />}

                <h1 className="partner-disabled__title">{data.message}</h1>

                {data.moreInfoMessage && data.moreInfoLink && (
                    <p className="partner-disabled__info">
                        {data.moreInfoMessage}{' '}
                        <a href={data.moreInfoLink} target="_blank" rel="noopener noreferrer">
                            here
                        </a>
                        .
                    </p>
                )}

                {data.contact && (
                    <p className="partner-disabled__contact">
                        Please reach out to <a href={`mailto:${data.contact}`}>{data.contact}</a> if you have any
                        further questions. Thank you!
                    </p>
                )}
            </div>
        </LandingPageLayout>
    );
};

export default PartnerDisabled;
